import axios from "axios";

// Attach access token for protected routes
axios.interceptors.request.use((config) => {
  if (config.url) {
    if (
      config.url.startsWith("/api/v3/autoname") ||
      config.url.startsWith("api/v3/autoname")
    ) {
      config.url = config.url.replace(
        "/api/v3/autoname",
        "/api/v3/pro/autoname"
      );
      config.url = config.url.replace(
        "api/v3/autoname",
        "api/v3/pro/autoname"
      );
    } else if (
      config.url.startsWith("/api/v3/name") ||
      config.url.startsWith("api/v3/name")
    ) {
      config.url = config.url.replace("/api/v3/name", "/api/v3/pro/name");
      config.url = config.url.replace("api/v3/name", "api/v3/pro/name");
    }
  }

  const needsAuth =
    config.url &&
    (config.url.startsWith("/api/v3/pro/") ||
      config.url.startsWith("api/v3/pro/") ||
      config.url.startsWith("/api/v3/title/") ||
      config.url.startsWith("api/v3/title/"));
  if (needsAuth) {
    const tokenPairRaw = localStorage.getItem("tokenPair");
    const tokenPair = tokenPairRaw ? JSON.parse(tokenPairRaw) : null;
    if (tokenPair?.access) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${tokenPair.access}`;
    }
  }
  return config;
});

// Refresh token on 401 responses
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;

    const needsAuth =
      config &&
      config.url &&
      (config.url.startsWith("/api/v3/pro/") ||
        config.url.startsWith("api/v3/pro/") ||
        config.url.startsWith("/api/v3/title/") ||
        config.url.startsWith("api/v3/title/"));
    if (response && response.status === 401 && needsAuth && !config._retry) {
      config._retry = true;

      try {
        const stored = localStorage.getItem("tokenPair");
        const pair = stored ? JSON.parse(stored) : null;
        if (!pair?.refresh) {
          throw new Error("No refresh token");
        }

        const refreshRes = await axios.post(
          "/api/v3/auth/refresh",
          null,
          {
            headers: {
              Authorization: `Bearer ${pair.refresh}`,
            },
          }
        );

        const newPair = refreshRes.data;
        localStorage.setItem("tokenPair", JSON.stringify(newPair));

        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${newPair.access}`;

        return axios(config);
      } catch (refreshError) {
        if (
          refreshError.response?.status === 403 ||
          !refreshError.response
        ) {
          localStorage.removeItem("tokenPair");
          window.location.href = "/login";
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
